// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.djelatnikProfil_backToContainer__dI\\+j0 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: fit-content;
  cursor: pointer;
}
.djelatnikProfil_backToh1__UnFCk {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
}
.djelatnikProfil_profileRow__2xY16 {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  justify-content: space-between;
  width: 100%;
}
.djelatnikProfil_rightColumn__fpEv2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
  width: 20%;
}
.djelatnikProfil_groupContent__tDX4C {
  margin-top: 3%;
  gap: 6px;
}
.djelatnikProfil_groupH1__t5t0o {
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  text-align: center;
  color: #4d4e4e;
}
.djelatnikProfil_biografijaBtn__O8NCA,
.djelatnikProfil_groupContent__tDX4C {
  display: flex;
  align-items: center;
  justify-content: center;
}
.djelatnikProfil_biografijaBtn__O8NCA {
  border-radius: 4px;
  background-color: #cb9c2d;
  column-gap: 8px;
  height: 52px;
  width: 15%;
  border: none;
  font-family: Inter;
  font-size: 15px;
  width: 100%;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  color: white;
  transition: background-color 300ms ease-in-out;
}

.djelatnikProfil_biografijaBtn__O8NCA:hover {
  background-color: #a37d25;
  cursor: pointer;
}
.djelatnikProfil_iconContainer__CxQPa {
  margin-top: 10%;
  display: flex;
  justify-content: center;
}

.djelatnikProfil_groupText__tAk\\+8 {
  font-family: "Inter";
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  color: #5f6d7e;
  width: 80%;
  margin-top: 1%;
}
.djelatnikProfil_groupsBadges__6f1ki {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.djelatnikProfil_groupBadge__5-ZOf {
  background-color: #f4f4f4;
  border-radius: 20px;
  padding: 8px;
}
.djelatnikProfil_groupBadgeText__3o78j {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px;
}

.djelatnikProfil_profilePic__5NhJ5 {
  position: relative;
  z-index: 10;
  transform: translate(-10%, 20%);
  width: 200px;
  margin-bottom: 40px;
  border: 10px solid white;
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 250px;
}

@media screen and (max-width: 900px) {
  .djelatnikProfil_profilePic__5NhJ5 {
    width: 220px;
  }
}

@media screen and (max-width: 750px) {
  .djelatnikProfil_profileRow__2xY16 {
    flex-direction: column;
    gap: 30px;
  }
  .djelatnikProfil_rightColumn__fpEv2 {
    width: 65%;
  }
}

@media screen and (max-width: 600px) {
  .djelatnikProfil_rightColumn__fpEv2 {
    width: 75%;
  }
  .djelatnikProfil_profilePic__5NhJ5 {
    width: 200px;
    max-height: 180px;
    transform: translate(-15%, 20%);
  }
}

@media screen and (max-width: 400px) {
  .djelatnikProfil_rightColumn__fpEv2 {
    width: 98%;
  }
  .djelatnikProfil_profilePic__5NhJ5 {
    width: 180px;
    max-height: 165px;
    transform: translate(-20%, 30%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/djelatnikProfil/djelatnikProfil.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;AACF","sourcesContent":[".backToContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  cursor: pointer;\n}\n.backToh1 {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n}\n.profileRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-start;\n  justify-content: space-between;\n  width: 100%;\n}\n.rightColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 16px;\n  width: 20%;\n}\n.groupContent {\n  margin-top: 3%;\n  gap: 6px;\n}\n.groupH1 {\n  font-family: \"Inter\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: #4d4e4e;\n}\n.biografijaBtn,\n.groupContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.biografijaBtn {\n  border-radius: 4px;\n  background-color: #cb9c2d;\n  column-gap: 8px;\n  height: 52px;\n  width: 15%;\n  border: none;\n  font-family: Inter;\n  font-size: 15px;\n  width: 100%;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: white;\n  transition: background-color 300ms ease-in-out;\n}\n\n.biografijaBtn:hover {\n  background-color: #a37d25;\n  cursor: pointer;\n}\n.iconContainer {\n  margin-top: 10%;\n  display: flex;\n  justify-content: center;\n}\n\n.groupText {\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  color: #5f6d7e;\n  width: 80%;\n  margin-top: 1%;\n}\n.groupsBadges {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n.groupBadge {\n  background-color: #f4f4f4;\n  border-radius: 20px;\n  padding: 8px;\n}\n.groupBadgeText {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n\n.profilePic {\n  position: relative;\n  z-index: 10;\n  transform: translate(-10%, 20%);\n  width: 200px;\n  margin-bottom: 40px;\n  border: 10px solid white;\n  border-radius: 4px;\n  box-sizing: border-box;\n  min-height: 250px;\n}\n\n@media screen and (max-width: 900px) {\n  .profilePic {\n    width: 220px;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .profileRow {\n    flex-direction: column;\n    gap: 30px;\n  }\n  .rightColumn {\n    width: 65%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .rightColumn {\n    width: 75%;\n  }\n  .profilePic {\n    width: 200px;\n    max-height: 180px;\n    transform: translate(-15%, 20%);\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .rightColumn {\n    width: 98%;\n  }\n  .profilePic {\n    width: 180px;\n    max-height: 165px;\n    transform: translate(-20%, 30%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backToContainer": `djelatnikProfil_backToContainer__dI+j0`,
	"backToh1": `djelatnikProfil_backToh1__UnFCk`,
	"profileRow": `djelatnikProfil_profileRow__2xY16`,
	"rightColumn": `djelatnikProfil_rightColumn__fpEv2`,
	"groupContent": `djelatnikProfil_groupContent__tDX4C`,
	"groupH1": `djelatnikProfil_groupH1__t5t0o`,
	"biografijaBtn": `djelatnikProfil_biografijaBtn__O8NCA`,
	"iconContainer": `djelatnikProfil_iconContainer__CxQPa`,
	"groupText": `djelatnikProfil_groupText__tAk+8`,
	"groupsBadges": `djelatnikProfil_groupsBadges__6f1ki`,
	"groupBadge": `djelatnikProfil_groupBadge__5-ZOf`,
	"groupBadgeText": `djelatnikProfil_groupBadgeText__3o78j`,
	"profilePic": `djelatnikProfil_profilePic__5NhJ5`
};
export default ___CSS_LOADER_EXPORT___;
